import { Injectable } from '@angular/core';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class ServiceAccountGuard {
    constructor(private authenticationService: AuthenticationService) {}

    canActivate(): boolean {
        return (
            this.authenticationService.isAuthenticated() &&
            !!this.authenticationService.user.serviceAccount
        );
    }
}
